import { useLocation, useNavigate } from "react-router-dom";

function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <footer className="w-full mt-auto">
      <div
        className={`container mx-auto flex flex-col sm:flex-row justify-between items-center px-4 sm:px-6 md:px-6 lg:px-8 xl:px-16 2xl:px-24 py-4 md:py-3 lg:py-4 ${
          location.pathname === "/sitemap" ? "lg:pt-0 lg:pb-3" : ""
        }`}
      >
        {/* Help Section */}
        <div className="flex flex-col sm:flex-row gap-2 lg:gap-4 items-center text-center sm:text-left mb-2 sm:mb-0">
          <button
            className="text-sm md:text-base 2xl:text-lg text-[#6C727F] focus:outline-none hover:underline"
            onClick={() => navigate("/faqs")}
          >
            Need help?
          </button>

          <button
            onClick={() => navigate("/sitemap")}
            className="text-sm md:text-base 2xl:text-lg text-[#6C727F] hover:underline"
          >
            Sitemap
          </button>

          <button
            className="text-sm md:text-base 2xl:text-lg text-[#6C727F] focus:outline-none hover:underline"
            onClick={() => navigate("/contact_us")}
          >
            Contact us
          </button>
        </div>

        {/* Copyright Section */}
        <h6 className="text-sm md:text-base 2xl:text-lg text-[#6C727F] text-center sm:text-right">
          © All rights reserved.
        </h6>
      </div>
    </footer>
  );
}

export default Footer;